export default __webpack_public_path__ + "static/media/trust-pilot.ef44da86.svg";